var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremiumDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 49,
    viewBox: "0 0 59 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0346 17.7116H2.56217C1.87161 17.7116 1.24867 17.2968 0.982236 16.6597C0.715911 16.0226 0.857966 15.2879 1.34292 14.7964L14.9865 0.963118C15.3084 0.636755 15.7476 0.453125 16.2059 0.453125H22.9421C23.5354 0.453125 24.0866 0.760231 24.3987 1.26501C24.7107 1.76968 24.7393 2.39987 24.4742 2.93082L17.5668 16.7641C17.2769 17.3448 16.6836 17.7116 16.0346 17.7116Z",
    fill: "#A0EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1375 17.7116H43.665C43.0159 17.7116 42.4228 17.3448 42.1328 16.7641L35.2253 2.93082C34.9602 2.39987 34.9889 1.76968 35.3009 1.26501C35.6128 0.760344 36.1642 0.453125 36.7574 0.453125H43.4936C43.9519 0.453125 44.3911 0.636868 44.713 0.963118L58.3567 14.7964C58.8415 15.288 58.9837 16.0229 58.7174 16.6597C58.4509 17.2969 57.828 17.7116 57.1375 17.7116Z",
    fill: "#73C8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1191 15.9544L22.9416 0.453125H36.7566L45.552 15.9544H14.1191Z",
    fill: "#D2F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8134 15.9547L28.2855 46.5187C27.9428 47.2927 28.2171 48.201 28.931 48.6559C29.2147 48.8367 29.5339 48.9245 29.8507 48.9245C30.3309 48.9245 30.8052 48.723 31.1408 48.339L58.4282 17.1264C58.7166 16.7965 58.8607 16.3766 58.8498 15.9546H41.8134V15.9547Z",
    fill: "#0073AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8867 15.9546H0.850182C0.839307 16.3765 0.983401 16.7965 1.27182 17.1264L28.5592 48.339C28.8948 48.723 29.3692 48.9245 29.8493 48.9245C30.1661 48.9245 30.4854 48.8368 30.7691 48.6559C31.4827 48.201 31.7571 47.2927 31.4145 46.5187L17.8867 15.9546Z",
    fill: "#41B4E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1191 15.9546L28.2832 47.905C28.5574 48.5247 29.1714 48.9244 29.8492 48.9244C30.5269 48.9244 31.1409 48.5247 31.4152 47.905L45.5521 15.9546H14.1191Z",
    fill: "#A0EBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8379 15.9544H45.5543L36.7588 0.453125H29.8379V15.9544Z",
    fill: "#41B4E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8496 48.9244C30.5274 48.9244 31.1414 48.5247 31.4156 47.905L45.5525 15.9546H29.8496V48.9244Z",
    fill: "#73C8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumDiamond);
export default __webpack_public_path__ + "static/media/premium-diamond.96633968e2a8a189fd48a25a1141fec0.svg";
export { ForwardRef as ReactComponent };